import React from 'react';

import usePreviewFeature from '../../hooks/usePreviewFeature';
import TestFinishLegacy from './TestFinishLegacy';
import TestResult from './TestResult';

const TestFinish = () => (usePreviewFeature('courses-redesign') ? <TestResult /> : <TestFinishLegacy />);

export default TestFinish;
